export enum FollowupActions {
  fetchFollowupsForDecree = '[Followups]: fetch Followups for decree',
  fetchFollowupsForDecreeSuccess = '[Followups]: fetch Followups for decree success',
  fetchFollowupsForDecreeFailure = '[Followups]:  fetch Followups for decree failure',
  publishFollowup = '[Followups]: publish Followup',
  publishFollowupSuccess = '[Followups]: publish Followup success',
  publishFollowupFailure = '[Followups]: publish Followup failure',
  removeFollowupTask = '[Followups]: remove Followup task',
  removeFollowupTaskSuccess = '[Followups]: remove Followup task success',
  removeFollowupTaskFailed = '[Followups]: remove Followup task failed',
  updateFollowupTask = '[Followups]: update Followup task',
  updateFollowupTaskSuccess = '[Followups]: update Followup task success',
  updateFollowupTaskFailed = '[Followups]: update Followup task failed',
  updateStatus = '[Followups]: update Followup task status',
  updateStatusSuccess = '[Followups]: update Followup task status success',
  updateStatusFailed = '[Followups]: update Followup task status failed',
  assignTasks = '[Followups]: assign tasks',
  assignTasksSuccess = '[Followups]: assign tasks success',
  assignTasksFailed = '[Followups]: assign tasks failed'
}
